module.exports = {
  contact: {
    badge: "Контакты",
    title: "Контакты",
    subtitle: "Минимальная контактная страница.",
    summaryTitle: "Связь",
    summaryText: "Эту страницу можно заполнить реальными контактами позже.",
    summaryPoints: ["Почта", "Телефон", "Telegram"],
    cardsTitle: "Каналы",
    cardsSubtitle: "Минимальный набор контактов.",
    cards: [
      { icon: "fas fa-envelope", title: "Email", text: "demo@smartteamdev.ru" },
      { icon: "fas fa-phone-volume", title: "Телефон", text: "+7 (495) 123-45-67" },
      { icon: "fab fa-telegram-plane", title: "Telegram", text: "@smartteamdev" }
    ],
    listTitle: "Следующие шаги",
    listSubtitle: "Простой список для будущего контента.",
    listItems: ["Написать", "Созвон", "Демо"],
    stats: [
      { value: "24ч", label: "ответ" },
      { value: "3", label: "канала" }
    ],
    ctaTitle: "Оставить заявку",
    ctaText: "Используйте этот блок для формы или CTA.",
    primaryHref: "mailto:demo@smartteamdev.ru",
    primaryLabel: "Написать",
    secondaryHref: "/pages/portal",
    secondaryLabel: "Portal",
    detailsTitle: "",
    details: [
      { icon: "fas fa-envelope", label: "", value: "", href: "mailto:" },
      { icon: "fas fa-phone-volume", label: "", value: "", href: "tel:" },
      { icon: "fab fa-telegram-plane", label: "", value: "", href: "" }
    ],
    formTitle: "",
    formText: ""
  }
};